<div class="flex flex-direction-row full-size" style="background: #F8F9FA; font-family: 'Open Sans';
font-style: normal">
    <div class="content-section flex flex-direction-column flex-grow max-width-minus-side-nav" style="--grow-value: 1">
        <app-page-header (clickedNav)="sideNavChange($event)"></app-page-header>
        <div class="main-content" *ngIf="essTabToShow == 'details'">
            <!-- <div class="tab-heading sub-page-name">Details</div> -->
            <div class="flex flex-direction-row tab-view-buttons">
                <ul class="nav nav-tabs fc-tabs width-100" id="essTabs" role="tablist">
                    <!-- SKS21NOV24 hiding static tabs from custom configuration -->
                    <li *ngFor="let tab of detailsTabsList; let i=index" class="nav-item" role="presentation">
                        <button *ngIf="!hideStaticDetailsTabs?.includes(tab.subTab)" class="nav-link" id="{{tab.name}}" data-bs-toggle="tab" type="button" role="tab" [class]="tab?.subTab === activeTab ? 'active': ''" (shown.bs.tab)="activeTabs(tab)" >
                            {{tab.name}}
                        </button>
                    </li>
                </ul>
            </div>

            <!-- SK01APR24 reducing api call for ess -->
            <div class="tab-content" id="essTabContent">
                <div *ngIf="activeTab === 'basicinfo' && !hideStaticLeavesTabs?.includes('basicinfo') ">
                    <app-basicinfotab [selectedUser]="selectedEmployee"></app-basicinfotab>
                </div>

                <div *ngIf="activeTab === 'work' && !hideStaticLeavesTabs?.includes('work') ">
                    <app-worktab [selectedUser]="selectedEmployee" [employeeFinanceInfo]="employeeFinanceInfo" [allEmployeeGet]="empGet"></app-worktab>
                </div>
                <div *ngIf="activeTab === 'qualification' && !hideStaticLeavesTabs?.includes('qualification') ">
                    <app-educationtab [selectedUser]="selectedEmployee"> </app-educationtab>
                </div>

                <div *ngIf="activeTab === 'experiences' && !hideStaticLeavesTabs?.includes('experiences') ">
                    <app-experiencetab [selectedUser]="selectedEmployee"> </app-experiencetab>
                </div>

                <div *ngIf="activeTab === 'documents' && !hideStaticLeavesTabs?.includes('documents') ">
                    <app-document [selectedUser]="selectedEmployee"> </app-document>
                </div>

                <div *ngIf="activeTab === 'dependents' && !hideStaticLeavesTabs?.includes('dependents') ">
                    <app-dependenttab [selectedUser]="selectedEmployee">  </app-dependenttab>
                </div>
                <div *ngIf="activeTab === 'bank' && !hideStaticLeavesTabs?.includes('bank') ">
                    <app-bankinfotab [selectedUser]="selectedEmployee" [employeeFinanceInfo]="employeeFinanceInfo">  </app-bankinfotab>
                </div>
                <div *ngIf="!detailsStaticTabs.includes(activeTab)">
                    <!-- SKS21NOV24 switch the dynamic content, such as card or table  -->
                    <div [ngSwitch]="dynamicComp">
                        <div *ngSwitchCase="'card'">
                            <div *ngFor="let card of dynamicTabContent">
                                <div class="form-card">
                                    <div class="col-md-12 mt-3">
                                        <div class="static-width-for-card width-100">
                                            <app-cards [inlineDetailed]="true">
                                                <div class="header-section flex content-space-between">
                                                    <span>{{card.label}}</span>
                                                    <div class="card-btn" *ngIf="card.isEditButton" (click)="onClickEdit(card)">
                                                        <svg-icon src="../assets/images/icons/general/pencil-icon.svg"
                                                            class="card-icon"></svg-icon>
                                                    </div>
                                                </div>
                                                <div class="body-section card-text">
                                                    <div class="flex">
                                                    <div class="row g-3 flex w-100">
                                                        <!-- SKS21NOV24 hiding the fields from custom cards -->
                                                        <div *ngFor="let detail of card.config.details" class="{{card.cardSize}} mt-3 mb-3" >
                                                        <div *ngIf="!detail?.hideFromCard" class=" d-flex flex-column">
                                                            <label class="label-head">{{detail.label}}</label>
                                                            <label class="label-sub">{{detail.value}}</label>
                                                        </div>
                                                        </div>
                                                    </div>
                                                    </div>
                                                </div>
                                            </app-cards>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngSwitchCase="'table'">
                        <app-data-table 
                            [tableId]="tableInputs?.tableId"
                            [searchBar]="tableInputs?.searchBar" 
                            [data]="data" 
                            [headerLabels]="tableInputs?.headerLabels"
                            [displayedColumns]="tableInputs?.displayedColumns"
                            [hyperLinkColumns]="tableInputs?.hyperLinkColumns"
                            [fromWhere]="tableInputs?.fromWhere"
                            [withCheckBox]="tableInputs?.withCheckBox"
                            [isButtons]="tableInputs?.isButtons"
                            [buttonArray]="tableInputs?.buttons"
                            [isEditRow]="tableInputs?.isEditRow" 
                            [isDeleteRow]="tableInputs?.isDeleteRow"
                            [actionButton]="tableInputs?.actionButton"
                            (commonButtonClickEmit)="commonButtonClickEmit($event, null)"
                            (selectedValues)="tableCheckedDataa($event)"
                            (hyperLinkColumnEmit)="hyperLinkColumnEmit($event)"
                            (onEditData)="onEditRecord($event)"
                            (OnDeleteData)="onDeleteRecord($event)"
                            [tableConfigurations]="tableInputs"
                            [sideScreenColumn]="tableInputs?.sideScreenColumn">
                        </app-data-table>
                        </div>
                    </div>     
                </div>
            </div>
        </div>

        <div class="main-content" *ngIf="essTabToShow == 'leaves'">
            <!-- <div class="tab-heading sub-page-name">Leaves</div> -->
            <div class="fc-tab-view">
                <div class="flex flex-direction-row fc-tab-buttons">
                    <ul class="nav nav-tabs fc-tabs" id="tabView" role="tablist">
                        <li *ngFor="let tab of leaveTabsList; let i=index" class="nav-item" role="presentation">
                            <button *ngIf="!hideStaticLeavesTabs?.includes(tab.subTab)" class="nav-link" id="{{tab.name}}" data-bs-toggle="tab" type="button" role="tab" [class]="tab?.subTab === activeTab ? 'active': ''" (shown.bs.tab)="activeTabs(tab)" >
                                {{tab.name}}
                            </button>
                        </li>
                    </ul>
                </div>
                <div class="tab-content" id="fcTabContent">
                    <div *ngIf="activeTab === 'applyLeave' && !hideStaticLeavesTabs?.includes('applyLeave') ">
                        <app-apply-leaves [selectedUser]="selectedEmployee"   [employeeLeaves]="employeeLeaves"></app-apply-leaves>
                    </div>
                    <!-- <div class="tab-pane fade" id="leavehistory-tab-pane" role="tabpanel" aria-labelledby="second-tab"
                        tabindex="0">
                        <app-Leave-history> </app-Leave-history>

                    </div> -->
                    <div *ngIf="activeTab === 'holidayDetails' && !hideStaticLeavesTabs?.includes('holidayDetails') ">
                        <app-holidaydetails [details]="holidays" [header]="['Holiday', 'Date']"> </app-holidaydetails>
                    </div>
                    <div *ngIf="activeTab === 'weekOff' && !hideStaticLeavesTabs?.includes('weekOff') ">
                        <app-holidaydetails [details]="weekOff" [header]="['Weekoff Type', 'Days']"> </app-holidaydetails>
                    </div>
                    <div *ngIf="!leaveStaticTabs.includes(activeTab)">
                        <div *ngFor="let comp of activeTabComp?.components">
                            <div *ngIf="comp?.type ==='buttons'" class="d-flex justify-content-end">
                                <app-fusion-button 
                                  *ngFor="let button of leaveButtonArray"
                                  (buttonClickEmit)="commonButtonClick(button)" 
                                  [buttonType]="button.class" 
                                  [buttonValue]="button.name" 
                                  class="ms-1 me-1">
                                </app-fusion-button>
                              </div>
                            <div *ngIf="comp?.type ==='card'">
                              <div *ngFor="let card of dynamicTabContent">
                                <div class="form-card">
                                  <div class="col-md-12 mt-3">
                                      <div class="static-width-for-card width-100">
                                          <app-cards [inlineDetailed]="true">
                                              <div class="header-section flex content-space-between">
                                                  <span>{{card.label}}</span>
                                                  <div class="card-btn" *ngIf="card.isEditButton" (click)="onClickEdit(card)">
                                                      <svg-icon src="../assets/images/icons/general/pencil-icon.svg"
                                                          class="card-icon"></svg-icon>
                                                  </div>
                                              </div>
                                              <div class="body-section card-text">
                                                <div class="flex">
                                                  <div class="row g-3 flex w-100">
                                                    <!-- SK25JUL24 hiding the fields from custom cards -->
                                                    <div *ngFor="let detail of card.config.details" class="{{card.cardSize}} mt-3 mb-3" >
                                                      <div *ngIf="!detail?.hideFromCard" class=" d-flex flex-column">
                                                        <label class="label-head">{{detail.label}}</label>
                                                        <label class="label-sub">{{detail.value}}</label>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                          </app-cards>
                                      </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div *ngIf="comp?.type ==='table'">
                              <app-data-table 
                                  [tableId]="tableInputs?.tableId"
                                  [searchBar]="tableInputs?.searchBar" 
                                  [data]="data" 
                                  [headerLabels]="tableInputs?.headerLabels"
                                  [displayedColumns]="tableInputs?.displayedColumns"
                                  [hyperLinkColumns]="tableInputs?.hyperLinkColumns"
                                  [fromWhere]="tableInputs?.fromWhere"
                                  [withCheckBox]="tableInputs?.withCheckBox"
                                  [isButtons]="tableInputs?.isButtons"
                                  [buttonArray]="tableInputs?.buttons"
                                  [isEditRow]="tableInputs?.isEditRow" 
                                  [isDeleteRow]="tableInputs?.isDeleteRow"
                                  [actionButton]="tableInputs?.actionButton"
                                  (commonButtonClickEmit)="commonButtonClickEmit($event, null)"
                                  (selectedValues)="tableCheckedDataa($event)"
                                  (hyperLinkColumnEmit)="hyperLinkColumnEmit($event)"
                                  (onEditData)="onEditRecord($event)"
                                  (OnDeleteData)="onDeleteRecord($event)"
                                  [actionButtonCondition]="tableInputs?.actionButtonCondition"
                                  [timeColumns]="tableInputs?.timeColumns"
                                  [dateColumns]="tableInputs?.dateColumns"
                                  [tableConfigurations]="tableInputs"
                                  [sideScreenColumn]="tableInputs?.sideScreenColumn">
                              </app-data-table>
                            </div>
                        </div> 
                    </div>
                </div>
            </div>
        </div>

        <div class="main-content" *ngIf="essTabToShow == 'expenses'">
            <app-expenses-tab [selectedUser]="selectedEmployee" [expenseHistory]="employeeExpenses"  [employeeExpenses]="employeeExpenses"></app-expenses-tab> 
        </div>
        
        <div class="main-content" *ngIf="essTabToShow == 'payslips'">
            <!-- SK02APR24 payslips module content, payslips will be listed in table with preview and download options -->
            <div class="fc-tab-view">
                <div class="flex flex-direction-row fc-tab-buttons">
                    <ul class="nav nav-tabs fc-tabs" id="paySlipTab" role="tablist">
                        <li class="nav-item" role="presentation">
                            <button class="nav-link active" id="payslip-first-tab" data-bs-toggle="tab"
                                data-bs-target="#payslip-tab-pane" type="button" role="tab"
                                aria-controls="payslip-tab-pane" aria-selected="true">Payslips</button>
                        </li>
                    </ul>
                </div>
                <div class="tab-content" id="fcTabContent">
                    <div class="card">
                        <div class="m-2">
                            <div class="tab-pane fade show active" id="payslip-tab-pane" role="tabpanel" aria-labelledby="first-tab" tabindex="0">
                                <app-data-table [data]="paySlipDatum" [displayedColumns]="['compensationId','month', 'netPay']" [headerLabels]="['Compensation Id','Payroll month', 'Net Pay']" fromWhere="common" [actionButton]="true" [viewIcon]="true" [downloadIcon]="true" (viewIconEmit)="viewIconEmit($event)" (downloadIconEmit)="downloadIconEmit($event)" [searchBar]="true"></app-data-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="main-content" *ngIf="essTabToShow == 'companypolicies'">
            Company Policies
        </div>

        <div class="main-content" *ngIf="essTabToShow == 'taxdeclarations'">
            <div class="fc-tab-view">
                <div class="flex flex-direction-row fc-tab-buttons justify-content-between">
                    <div>
                        <ul class="nav nav-tabs fc-tabs" id="tabView" role="tablist">
                            <!-- <li class="nav-item" role="presentation">
                                <button class="nav-link active" id="comp-ess-tab-tab" data-bs-toggle="tab"
                                    data-bs-target="#comp-ess-tab-pane" type="button" role="tab"
                                    aria-controls="comp-ess-tab-pane" aria-selected="true">Compensation</button>
                            </li> -->
                            <li class="nav-item" role="presentation">
                                <button class="nav-link active" id="tax-ess-tab" data-bs-toggle="tab"
                                    data-bs-target="#tax-ess-tab-pane" type="button" role="tab"
                                    aria-controls="tax-ess-tab-pane" aria-selected="false" (shown.bs.tab)="getUserData()">IT Declaration</button>
                            </li>
                            <!-- <li class="nav-item" role="presentation">
                                <button class="nav-link" id="proof-ess-tab" data-bs-toggle="tab"
                                    data-bs-target="#proof-ess-tab-pane" type="button" role="tab"
                                    aria-controls="proof-ess-tab-pane" aria-selected="false">Proof Of Investments</button>
                            </li> -->
                        </ul>
                    </div>
                    <div>
                        <app-drop-down [lists]="fyList" dropDownWidth="200px" (dataEmit)="finYear($event)" [selectedData]="selectedFinancialYear"></app-drop-down>
                    </div>
                </div>
                <div class="tab-content w-85" id="fcTabContentTaxESS">
                    <div class="tab-pane fade" id="comp-ess-tab-pane" role="tabpanel"
                        aria-labelledby="first-tab" tabindex="0">
                        Compensation ESS
                    </div>
                    <div class="tab-pane fade show active" id="tax-ess-tab-pane" role="tabpanel" aria-labelledby="second-tab"
                        tabindex="1">
                        <app-it-ess [financialYear]="selectedFinancialYear"></app-it-ess>
                    </div>
                    <div class="tab-pane fade" id="proof-ess-tab-pane" role="tabpanel" aria-labelledby="third-tab"
                        tabindex="2">
                        Proof OF IT
                    </div>
                </div>
            </div>
        </div>

        <div class="main-content" *ngIf="essTabToShow == 'companyorgchart'">
            Company Org Chart
        </div>
    </div>
    <!-- <app-global-app-tabs style="width: 100px"></app-global-app-tabs> -->
</div>

<app-modal [modalTitle]="modalProp?.modalTitle" [isModalOpen]="openModal" [modalFooter]="false" (cancelButtonEmit)="modalClose($event)" [modalSize]="modalProp?.modalSize">
    <div class="modal-body">
      <div>
        <iframe *ngIf="payslipFile" class="w-100 h-100" [src]="payslipFile" style="height: 500px !important;"></iframe>
      </div>
    </div>
  </app-modal>
  <!-- SKS21NOV24 modal open on clicking card edit -->
  <!-- SKS21NOV24 if condition updated-->
  <app-modal [modalTitle]="modalProperties?.modalTitle" [modalFooter]="modalProperties?.isModalFooter" [saveButtonValue]="modalProperties?.modalSaveButtonValue" [isModalOpen]="openModal" (cancelButtonEmit)="modalClose($event)" [modalSize]="modalProperties?.modalSize">
    <div class="modal-body">
      <div>
        <lib-booklet [bookletJSON]="nxtJSON"  [dataBind]="bookValue" [languageCode]="languageCode" (handleBookletActionEvent)="nxtFormHandlerESS($event)" (handleCalendarDate) = "handleCalendarDate($event)" (handleCalendarEvent) = "handleCalendarEvent($event)"></lib-booklet>
      </div>
    </div>
  </app-modal>